import { Box, Button, Card, CardContent, CircularProgress, Grid, TextareaAutosize, Typography } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
import { useFormik } from 'formik';
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../Helpers/Context/AppContext";
import { generateFormFields } from "../Helpers/Form"
import { buttonStyle, inputStyle } from "../Helpers/InlineStyles";
import { ErrorMessage } from "../Alert/Alert";
import { CMAutoComplete } from "../AutoComplete/AutoComplete";
import { CMButton, CMLinkButton } from "../Button/Button";
import { CMTextField } from "../TextField/CMSTextField";
import { CMToggleSwitch } from "../ToggleSwitch/ToggleSwitch";
import { CMLabel } from "./FormLabels";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { PageRoutes } from "../../../constants";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import styled from "@emotion/styled";
import { CMFileUpload } from "./Input";
import { CMRichTextEditor } from "../RichTextEditor/RichTextEditor";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const routeLinks: any = PageRoutes;

const TextField = (props: any) => {

    const { item, formik, handleChange } = props;
    return <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <CMTextField disabled={item.disabled}
            //  sx={inputStyle}
            name={item.name} placeholder={item.placeholder}
            onChange={(e: any) => handleChange(item.name, e)}
            error={formik.touched[item.name] && Boolean(formik.errors[item.name])}
            helperText={formik.touched[item.name] && formik.errors[item.name]}
            value={formik.values[item.name]}
            title={formik.values[item.name]}
        />
    </React.Fragment>
}
const FileUpload = (props: any) => {

    const { item, formik, handleChange } = props;
    return <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <CMFileUpload
            value={formik.values[item.name]}
            onChange={(e: any) => handleChange(item.name, e)}
            error={formik.touched[item.name] && Boolean(formik.errors[item.name])}
            helperText={formik.touched[item.name] && formik.errors[item.name]}
        />
    </React.Fragment>
}

const TextEditor = (props:any) =>{
    const { item, formik, handleChange } = props;
    return <>
     <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <CMRichTextEditor value={formik.values[item.name]} onChange={(e: any) => handleChange(item.name, e)}/>
        </React.Fragment>
    </>   
}

const Dropdown = (props: any) => {
    const { item, formik, handleChange } = props;

    return <>
        {
            typeof formik.values[item.name] == "object" ?
                <React.Fragment>
                    <CMLabel>{item.label}</CMLabel>
                    <CMAutoComplete
                        options={item.options}
                        disabled={item.disabled}
                        placeholder={item.placeholder}
                        onChange={(val: any) => handleChange(item.name, val)}
                        name={item.name}
                        value={formik.values[item.name]}
                        errors={formik.touched[item.name] && Boolean(formik.errors[item.name])}
                        helperText={formik.touched[item.name] && formik.errors[item.name]}
                    />
                </React.Fragment> : <React.Fragment>
                    <CMLabel>{item.label}</CMLabel>
                    <CMAutoComplete
                        options={item.options}
                        disabled={item.disabled}
                        placeholder={item.placeholder}
                        onChange={(val: any) => handleChange(item.name, val)}
                        name={item.name}
                        value={formik.values[item.name]}
                        errors={formik.touched[item.name] && Boolean(formik.errors[item.name])}
                        helperText={formik.touched[item.name] && formik.errors[item.name]}
                    />
                </React.Fragment>

        }
    </>

}
const CMDatePicker = (props: any) => {
    const { item, formik, handleChange } = props;
    return <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                slotProps={{ textField: { fullWidth: true, size: 'small', name: item.name } }}
                format="DD-MM-YYYY"
                value={dayjs(formik.values[item.name])}
                onChange={(val: any) => handleChange(item.name, val)} />
        </LocalizationProvider>
    </React.Fragment>
}

const CMTimePicker = (props: any) => {
    const { item, formik, handleChange } = props;
    return <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker slotProps={{ textField: { fullWidth: true, size: 'small', name: item.name } }}
                format="HH:MM"
                value={formik.values[item.name]}
                onChange={(val: any) => handleChange(item.name, val)} />
        </LocalizationProvider>
    </React.Fragment>

}
export const ToggleSwitch = (props: any) => {

    const { item, formik, handleChange } = props;
    return <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <CMToggleSwitch checked={formik.values[item.name]}
            onChange={(e: any) => handleChange(item.name, e)}
            name={item.name} color={'primary'} />
    </React.Fragment>
}
const Number = (props: any) => {

    const { item, formik, handleChange } = props;
    return <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <CMTextField disabled={item.disabled}
            //  sx={inputStyle}
            type={"number"}
            name={item.name} placeholder={item.placeholder}
            onChange={(e: any) => handleChange(item.name, e)}
            error={formik.touched[item.name] && Boolean(formik.errors[item.name])}
            helperText={formik.touched[item.name] && formik.errors[item.name]}
            value={formik.values[item.name]}
        />
    </React.Fragment>
}


const ChooseFile = (props: any) => {

    const { item, formik, handleChange } = props;
    return <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <CMTextField disabled={item.disabled}
            //  sx={inputStyle}
            type={"file"}
            name={item.name} placeholder={item.placeholder}
            onChange={(e: any) => handleChange(item.name, e)}
            error={formik.touched[item.name] && Boolean(formik.errors[item.name])}
            helperText={formik.touched[item.name] && formik.errors[item.name]}
            value={formik.values[item.name]}
        />
    </React.Fragment>
}

const Password = (props: any) => {

    const { item, formik, handleChange } = props;
    return <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <CMTextField disabled={item.disabled}
            //  sx={inputStyle}
            type="password"
            name={item.name} placeholder={item.placeholder}
            onChange={(e: any) => handleChange(item.name, e)}
            error={formik.touched[item.name] && Boolean(formik.errors[item.name])}
            helperText={formik.touched[item.name] && formik.errors[item.name]}
            value={formik.values[item.name]}
        />
    </React.Fragment>
}
const TextArea = (props: any) => {
    const { item, formik, handleChange } = props;
    return <React.Fragment>
        <CMLabel>{item.label}</CMLabel>
        <CMTextField
            disabled={item.disabled}
            minRows={4}
            multiline={true}
            name={item.name} placeholder={item.placeholder}
            onChange={(e: any) => handleChange(item.name, e)}
            error={formik.touched[item.name] && Boolean(formik.errors[item.name])}
            helperText={formik.touched[item.name] && formik.errors[item.name]}
            value={formik.values[item.name]}
        />
    </React.Fragment>
}

export const CMForm = (props: any) => {
    const { formFields, validationSchema, detailService, type } = props;
    const [formFieldValues, setFormFieldValues] = React.useState<any>([]);
    useEffect(() => {
        generateFormFields(formFields).then((res: any) => {
            setFormFieldValues(res)
        })
            .catch(err => {
                setFormFieldValues([])
            })
    }, [])

    const history = useNavigate();

    const { globalData, setGlobalData } = React.useContext(AppContext)
    const [showError, setShowError] = React.useState(false)
    const [error, setError] = React.useState("")

    const { id } = useParams();

    const formik: any = useFormik({
        initialValues: props.initialValues ? props.initialValues : {},
        validationSchema: validationSchema,
        onSubmit: (values: any) => {
            
            setShowError(false);
            setGlobalData({
                ...globalData,
                loading: true
            });
            let json: any = {};
            Object.keys(values).forEach((item: any) => {
                if (typeof values[item] == 'object') {
                    if (values[item]['$d']) {
                        json[item] = dayjs(values[item]['$d']).format('YYYY-MM-DD')
                    }
                    else {
                        json[item] = values[item].id;
                    }
                } else {
                    json[item] = values[item];
                }
            })
            let service: any = type == 'edit' ? props.addService(json, id + "") : props.addService(json);
            service.then((result: any) => {
                setGlobalData({
                    ...globalData,
                    loading: true
                });
                if(type =='edit'){
                    toast.success("Record Updated Successfully")
                }else{
                    toast.success("Record Created Successfully")
                }
                history(routeLinks[props.listPageKey]);
            },
                (error: any) => {
                    setGlobalData({
                        ...globalData,
                        loading: false
                    })
                    setShowError(true)
                    setError(error)
                });
        },
    });

    const hideErrorWindow = () => {
        setShowError(false);
    }

    const [loading,setLoading] = React.useState<any>(false)
    React.useEffect(() => {
        if (formFieldValues.length) {
            setLoading(true)
            formFieldValues.forEach((item: any) => {
                if (item.default) {
                    formik.setFieldValue(item.name, item.default)
                } else {
                    if (item.type == 'dropdown')

                        formik.setFieldValue(item.name, item.options[0])
                    else
                        formik.setFieldValue(item.name, '')

                }
            })
            if (type == 'edit') {
                setShowError(false);
                setGlobalData({
                    ...globalData,
                    loading: true
                });
                detailService(id + "").then((res: any) => {
                    formik.setValues(res);
                    formFieldValues.forEach((item: any) => {

                        if (item.type == 'dropdown') {
                            let option = item.options.find((x: any) => x.id == res[item.name]);
                            setTimeout(() => {
                                formik.setFieldValue(item.name, option)
                            }, 1000)

                        }
                    })
                    setShowError(false);
                    setGlobalData({
                        ...globalData,
                        loading: false
                    })
                    setTimeout(()=>{
                        setLoading(false);
                    },1000)
                    
                }).catch((err: any) => {
                    setShowError(true);
                    setError(error)
                    setGlobalData({
                        ...globalData,
                        loading: false
                    })
                    setLoading(false);
                })
            }else{
                setTimeout(()=>{
                    setLoading(false);
                },100)
            }
        }

    }, [formFieldValues]);


    const handleChange = (field: any, value: any) => {
        formik.setFieldValue(field, value);
    }

    return (
        (formFieldValues.length < 1 || loading) ? <Card sx={{ padding: "10px", "display": "flex", justifyContent: "center" }}><CircularProgress /></Card> :
            <form onSubmit={formik.handleSubmit}>
                <Card>
                    <CardContent>
                        {
                            showError ?
                                <ErrorMessage onClick={hideErrorWindow} message={error} /> : null
                        }
                        <Grid container spacing={3}>
                            {
                                formFieldValues.map((item: any, index: number) => {
                                    return (
                                        <Grid item xs={12} lg={(formFieldValues.length == 1) || item.fullWidth ? 12 : 6} md={(formFieldValues.length == 1) || item.fullWidth ? 12 : 6} sm={(formFieldValues.length == 1) || item.fullWidth ? 12 : 6} key={"te" + index}>

                                            {
                                                item.type == 'text' ?
                                                    <TextField item={item} formik={formik} handleChange={handleChange} />
                                                    : item.type == 'dropdown' ?
                                                        <Dropdown item={item} formik={formik} handleChange={handleChange} /> :
                                                        item.type == 'toggle' ?
                                                            <ToggleSwitch formik={formik} handleChange={handleChange} item={item} /> :
                                                            item.type == 'date' ?
                                                                <CMDatePicker formik={formik} handleChange={handleChange} item={item} /> :
                                                                item.type == 'time' ?
                                                                    <CMTimePicker formik={formik} handleChange={handleChange} item={item} /> :
                                                                    item.type == 'number' ?
                                                                        <Number formik={formik} handleChange={handleChange} item={item} /> :
                                                                        item.type == 'file' ?
                                                                            <FileUpload item={item} formik={formik} handleChange={handleChange} /> :
                                                                            item.type == 'password' ?
                                                                                <Password item={item} formik={formik} handleChange={handleChange} /> :
                                                                                item.type == 'textarea' ?
                                                                                    <TextArea item={item} formik={formik} handleChange={handleChange} /> :
                                                                                    item.type == 'texteditor' ?
                                                                                        <TextEditor item={item} formik={formik} handleChange={handleChange} /> :
                                                                                    null
                                            }
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                        <Box component='div'
                            sx={buttonStyle}
                        >
                            <Box component='span' mr={2}>
                                <CMLinkButton variant="contained" color="secondary" value="Cancel"
                                    link={PageRoutes[props.listPageKey]}
                                />
                            </Box>
                            <Box component='span'>
                                <CMButton variant="contained" value="Submit" color="primary" type="submit"></CMButton>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </form>
    )
}
